import { useSyncExternalStore } from 'react';

import { storage, type StorageKey, type StorageMap } from './index';

export function useStorageValue<K extends StorageKey>(key: K): StorageMap[K] | null {
  return useSyncExternalStore(
    fn =>
      storage.subscribe(key, () => {
        fn();
      }),
    () => storage.get(key)
  );
}
